import React, { ReactNode } from 'react';
import { Field, Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { I18n } from 'react-redux-i18n';
import Button from '../../../../common/Button';
import { UserDTO } from '../../../../../network/api/types/compte/UserDTO';
import { EmailsDTO } from '../../../../../network/api/types/EmailsDTO';
import TextInput from '../../../../common/inputs/TextInput';
import compteApi from '../../../../../network/api/compteApi';
import { FieldErrorDTO } from '../../../../../network/api/types/compte/FieldErrorDTO';
import { notifyErrorWithMessage, notifySuccess } from '../../../../common/Notification';
import { ErrorDTO } from '../../../../../network/api/types/compte/ErrorDTO';
import { validateEmail } from '../../../../../services/utils';

type Props = {
  onClose: () => void
  userDetails?: UserDTO
  fetchEmergencyInfos: () => void
  setDirty: (dirty: boolean, callback?: () => void) => void
  setModalI18n: (title: string, subtitle: string) => void
};

type State = {
  previousMail: string
  submitted: boolean
};

class EmergencyInformationForm extends React.Component<Props, State> {
  state: State = {
    previousMail: '',
    submitted: false,
  };

  componentDidMount(): void {
    this.props.setModalI18n('HOME.CONFIRM_MODAL_TITLE', 'EMERGENCY_INFORMATION.CONFIRM_CLOSE');
    this.setState({ previousMail: this.props.userDetails?.email });
  }

  handleEdit = async (values: EmailsDTO): Promise<{ [FORM_ERROR]: FieldErrorDTO[] }> => {
    try {
      return compteApi.saveEmergencyInfo({
        personalEmail: values.personalEmail,
        backupEmail: values.backupEmail || '',
      })
        .then(() => {
          this.props.fetchEmergencyInfos();
          this.props.setDirty(false);
          this.props.onClose();
          if (values.personalEmail !== this.state.previousMail) {
            notifySuccess(`${I18n.t('EMERGENCY_INFORMATION.NEW_MAIL_CONFIRM')} ${values.personalEmail}`);
          } else {
            notifySuccess(I18n.t('EMERGENCY_INFORMATION.BACKUPMAIL_UPDATE_SUCCESS'));
          }
        })
        .catch((err) => {
          if (typeof err.then === 'function') {
            err.then((e: ErrorDTO) => {
              notifyErrorWithMessage(e.fieldErrors[0]?.message);
            });
          } else {
            notifyErrorWithMessage(I18n.t('message.ERROR_MODIF'));
          }
          return null;
        });
      // const json = await
    } catch (err) {
      return { [FORM_ERROR]: [] };
    }
  };

  onFormChange = (dirty: boolean, dirtySinceLastSubmit: boolean): void => {
    const setDirty = this.state.submitted ? dirtySinceLastSubmit : dirty;
    this.props.setDirty(setDirty);
  };

  render(): ReactNode {
    if (!this.props.userDetails) {
      return false;
    }
    return (
      <Form
        onSubmit={this.handleEdit}
        initialValues={{
          personalEmail: this.props.userDetails?.email,
          backupEmail: this.props.userDetails?.backupEmail,
        }}
        validate={() => ({})}
        render={({
          handleSubmit,
          form,
          submitError,
        }) => {
          const getErrorMessage = (fieldName: string): string => {
            if (submitError) {
              return submitError.find((error: FieldErrorDTO) => error.field === fieldName)?.message;
            }
            return '';
          };
          return (
            <form
              className="connection-information-form"
              onSubmit={((this.state.submitted
                ? form.getState().dirtySinceLastSubmit : form.getState().dirty)
                ? handleSubmit : this.props.onClose)}
              onChange={() =>
                this.onFormChange(form.getState().dirty, form.getState().dirtySinceLastSubmit)}
            >
              <Field
                name="personalEmail"
                component={TextInput}
                placeholder={I18n.t('HOME.RECOVERY_MAIL')}
                type="text"
                customError={getErrorMessage('personalEmail')}
                validate={validateEmail}
                subtext={I18n.t('EMERGENCY_INFORMATION.NEW_MAIL_SUBTEXT')}
              />
              <Field
                name="backupEmail"
                component={TextInput}
                placeholder={I18n.t('HOME.EMERGENCY_MAIL')}
                type="text"
                customError={getErrorMessage('backupEmail')}
                validate={validateEmail}
              />
              <div className="button-container">
                <Button
                  type="third"
                  onClick={this.props.onClose}
                  i18nKey="actions.CANCEL"
                />
                <Button
                  type="primary"
                  buttonType="submit"
                  i18nKey="actions.SAVE"
                />
              </div>
            </form>
          );
        }}
      />
    );
  }
}

export default EmergencyInformationForm;
